// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1WoXz","bigColWidth":"Table_bigColWidth__1p44q","biggerColWidth":"Table_biggerColWidth__FcyLL","row":"Table_row__rLTFv","col":"Table_col__2spKH"};